<template>
  <div class="tables-basic">

    <h2 class="page-title">Vulnerability Details</h2>
      <div v-if="loading" class="page-loading-container">
          <b-spinner label="Loading..." ></b-spinner>
      </div>
      <div v-else>
    <b-row>
      <b-col>
        <Widget
        >
          <b-row >
            <b-col lg="12" sm="12" xs="12">

                <table class="table table-hover" >
                    <thead>
                    <tr>
                        <th scope="col" width="70%">Library</th>
                        <th scope="col">Vulnerability Count</th>
                        <th scope="col">Severity</th>

                    </tr>
                    </thead>
                    <tbody>
                    <tr class="spelling" v-for="(item, index) in vulnerabilities">
                        <td class="td-entry" >
                            <div :class="`console-logs console-logs-${item.type}`">
                                <i v-if="item.severity === 'Medium'" :class="`fa fa-warning log-${item.type}`" title="Warning" ></i>
                                <i v-if="item.severity === 'High'" :class="`fa fa-times-circle log-${item.type}`" title="Error"></i>
                                <a :href="item.snyk" target="_blank">{{item.library}}</a>
                            </div>
                        </td>
                        <td>{{item.vulnerability_count}}</td>
                        <td>{{item.severity}}</td>

                    </tr>
                    </tbody>
                </table>
                <h4>Pages</h4>
                <table class="table table-hover">
                    <tr v-for="page in pages">
                        <td width="80%"><a :href="page.url" target="_blank" v-b-tooltip.hover title="External Link">{{page.url}}</a></td>
                        <td> <router-link :to="{ name: 'ExplorePageDetails', query: {url: page.path} }" v-b-tooltip.hover  title='Page Details' ><i class="fa fa-eye"></i> Page Details</router-link></td>
                    </tr>
                </table>


            </b-col>
          </b-row>
        </Widget>

      </b-col>
    </b-row>
      </div>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import gql from "graphql-tag";
import { mapState } from 'vuex';
import axios from "axios";
export default {
  name: 'Tables',
  components: { Widget },
  apollo: {
    $subscribe: {
      websites_website: {
        query() {
          return gql`subscription {
                  websites_website(where: {id: {_eq: ${this.activeSite.id}}}) {
                      websites_vulnerabilities(where: {id: {_eq: "${this.vulnerabilityId}"}}, limit: 1){
                          severity
                          library
                          vulnerability_count
                          snyk
                          websites_vulnerability_pages(where:{websites_crawledpage: {is_latest: {_eq: true}}}, order_by: {id: asc}, limit: 50){
                            websites_crawledpage{
                              id
                              url
                              path
                            }
                          }
                        }
                  }
          }`
        },
        skip () {
          return !(this.activeSite.id && this.vulnerabilityId) || (this.dataLoaded && this.scanStatus.completed);
        },
        result (data) {

          this.vulnerabilities = [];
          for (let entry of data.data.websites_website[0].websites_vulnerabilities){
            let consoleEntry = {
              library: entry.library,
              severity: entry.severity,
              snyk: entry.snyk,
              vulnerability_count: entry.vulnerability_count,
              pages: [],
            };

            for (let page of entry.websites_vulnerability_pages){
                this.pages.push({
                  url: page.websites_crawledpage.url,
                  path: page.websites_crawledpage.path,
                })
            }
            this.vulnerabilities.push(consoleEntry)
          }
          this.loading = false;
          this.dataLoaded = true;
        },

      },

    }
  },
  data() {
    return {
      pages: [],
      loading: true,
      dataLoaded: false,
      vulnerabilityId: null,
      toastOptions: {
        theme: 'dark',
        position: 'bottomLeft',
      },
      vulnerabilities: [],
      currentPage: 2,
      numberOfPages: 1,
      pageSize: 15,
      row_selected: false,
    };
  },
  computed: {
    ...mapState({activeSite: 'activeSite', scanStatus: "scanStatus"}),
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Log Details - PageWatch.dev',
    // all titles will be injected into this template
  },
  watch: {
    'activeSite': function () {
      this.dataLoaded = false;
    }
  },
  methods: {
    linkGen(hash) {
      if (!hash){
        hash = '';
      }
      return (pageNum) =>{
        return pageNum === 1 ? `?${hash}` : `?page=${pageNum}${hash}`
      };
    },
    mouseOver(spellingError, index){
      spellingError.selectedPageIndex = index;
    },
  },
  created() {
        this.$watch("$route",() => {
          this.vulnerabilityId = this.$route.query.id || 1;
          this.dataLoaded = false;
        }, {
      immediate: true
    });
  }
};
</script>

<style lang="scss">
    .link-redirect {
        font-size:9pt;
        color:gray;
        padding:4px;
    }
    .link-status-redirect{
        color:red;
        font-size:9pt;
        padding:4px;
    }
    .link-entry{
        max-width:580px;
        overflow:auto;
    }
    .broken-link-preview-image {
        border-radius: 50%;
        max-width: 250px;
        box-shadow: #bdc4e0 0px 0px 20px;
    }
</style>
